module.exports = __webpack_public_path__ + "img/48.d6b8f81f.jpg";